<div [@comments]="'in'" *ngFor="let comment of comments;trackBy:commentId">
    <div class="comment-holder"  [ngClass]="{'resolved-comments':comment.resolved}" *ngIf="(!comment.resolved || showResolved) && (!commentor.filter ||commentor?.filter.length===0 || commentor.filter.includes(comment.id))">
      <app-comment-card [comment]="comment" [ngClass]="{'other-user':comment.user.username!==userService.userInfo?.username}" (resolveComment)="resolve(comment)"></app-comment-card>
      <div class="sub-comments">
        <div *ngFor="let sub_comment of comment.replies;trackBy:commentId">
          <div [ngClass]="{'resolved-comments':sub_comment.resolved}" *ngIf="!sub_comment.resolved || showResolved">
            <app-comment-card [@replies]="'in'" [comment]="sub_comment" [ngClass]="{'other-user':sub_comment.user.username!==userService.userInfo?.username}" (resolveComment)="resolve(sub_comment)"></app-comment-card>
          </div>
        </div>
      </div>
      <div *ngIf="replyingTo === comment.id" [@input]="'in'" class="animation-container">
        <div style="position:relative;">
          <editor class="nb-form-field-wrapper" apiKey="test" [init]="editor_options" [(ngModel)]="newComment">
            <app-comment-list [item]="item" [info]="info"></app-comment-list>
          </editor>
          <div [mention]="users" [mentionConfig]="config" #ment="mention" (searchTerm)="searchUser($event)"></div>
        </div>
        <button pButton (click)="addComment(newComment, comment.target, comment.key)" [disabled]="newComment.length === 0">{{'reply'| translation}}</button>
      </div>
      <button [@input]="'in'" *ngIf="!replyingTo || replyingTo !== comment.id" pButton (click)="replyingTo = comment.id">{{'reply_new'| translation}}</button>
    </div>
  </div>
  <div *ngIf="!replyingTo && !hideClose" [@input]="'in'" class="animation-container" >
    <div style="position:relative;">

      <editor class="nb-form-field-wrapper" apiKey="test" [init]="editor_options" [(ngModel)]="newComment"></editor>
      <div [mention]="users" [mentionConfig]="config" #ment="mention" (searchTerm)="searchUser($event)"></div>
    </div>
    <button pButton (click)="addComment(newComment)" [disabled]="newComment.length == 0">{{'comment'| translation}}</button>
  </div>
  <button [@input]="'in'" *ngIf="replyingTo" pButton (click)="replyingTo = null">{{'comment_new'| translation}}</button>



